"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isH5 = isH5;
const tslib_1 = require("tslib");
const fego_render_1 = tslib_1.__importDefault(require("@futuweb/fego-render"));
const fego_editor_1 = tslib_1.__importDefault(require("@futuweb/fego-editor"));
const PAGE_TYPE_ENUM = {
    H5: 1,
    PC: 10,
};
function isH5() {
    var _a;
    let route = null;
    if (fego_render_1.default) {
        const { store } = fego_render_1.default;
        route = store.route;
    }
    else {
        const { app: { project } } = fego_editor_1.default;
        route = project.route;
    }
    return +((_a = route === null || route === void 0 ? void 0 : route.now) === null || _a === void 0 ? void 0 : _a.pageType) === PAGE_TYPE_ENUM.H5;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQTRCSSxvQkFBSTs7QUE1QlIsK0VBQThDO0FBQzlDLCtFQUE4QztBQUU5QyxNQUFNLGNBQWMsR0FBRztJQUNuQixFQUFFLEVBQUUsQ0FBQztJQUNMLEVBQUUsRUFBRSxFQUFFO0NBQ1QsQ0FBQTtBQUVELFNBQVMsSUFBSTs7SUFDVCxJQUFJLEtBQUssR0FBRyxJQUFJLENBQUM7SUFDakIsSUFBSSxxQkFBVSxFQUFFLENBQUM7UUFDYixNQUFNLEVBQ0YsS0FBSyxFQUNSLEdBQUcscUJBQVUsQ0FBQztRQUNmLEtBQUssR0FBRyxLQUFLLENBQUMsS0FBSyxDQUFDO0lBQ3hCLENBQUM7U0FBTSxDQUFDO1FBQ0osTUFBTSxFQUNGLEdBQUcsRUFBRSxFQUNELE9BQU8sRUFDVixFQUNKLEdBQUcscUJBQVUsQ0FBQTtRQUNkLEtBQUssR0FBRyxPQUFPLENBQUMsS0FBSyxDQUFDO0lBQzFCLENBQUM7SUFFRCxPQUFPLENBQUMsQ0FBQSxNQUFBLEtBQUssYUFBTCxLQUFLLHVCQUFMLEtBQUssQ0FBRSxHQUFHLDBDQUFFLFFBQVEsQ0FBQSxLQUFLLGNBQWMsQ0FBQyxFQUFFLENBQUM7QUFDdkQsQ0FBQyJ9